<div class="gallery-card" [attr.data-gtm-label]="gtmLabel">
    <div class="status" [style.color]="getColorByStatus()">
        <span class="status-indicator" [style.backgroundColor]="getColorByStatus()"></span>{{ 'status-gallery.' + gallery.status | translate }}
    </div>

    <ng-container *ngIf="gallery.images.length > 0; else placeholder">
        <img [src]="getMainImageUrl()" alt="Gallery image" class="gallery-image" />
    </ng-container>

    <ng-template #placeholder>
        <div class="gallery-image placeholder"></div>
    </ng-template>


    <div class="gallery-info">
        <div class="gallery-name">{{ gallery.name }}</div>
        <div class="photo-count">
            <svg class="icon-photo" viewBox="0 0 24 24">
                <path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM5 5h14v4l-3-3-4 4-3-3-4 4V5z"/>
            </svg>
            {{ photoLabel }}
        </div>
    </div>
</div>
